import type { IconDefinition } from '../index.tsx';

export const iconJersey_Football: IconDefinition = {
  prefix: 'fas',
  iconName: 'iconJersey_Football',
  icon: [
    16,
    16,
    [],
    '',
    'M3.7334 13.1206H12.2666V14.8267H3.7334V13.1206ZM8 7.81982L13.6104 2.21045L16 4.05322L13.6533 6.45361L12.2666 5.43994V11.4136H3.7334V5.43994L2.34668 6.45361L0 4.05322L2.38965 2.20947L8 7.81982ZM6.08008 1.17334L8 3.09326L9.91992 1.17334H12.2334L8 5.40674L3.7666 1.17334H6.08008Z',
  ],
};
